<template>
  <fragment>
    <TextList :title="'服务类型'"></TextList>
  </fragment>
</template>

<script>
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import TextList from "@/components/common/TextList.vue";

export default {
  mixins: [ComponentBase],
  components: { TextList },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped></style>
